import React from 'react';
import classNames from 'classnames';
import {Loader} from "@eika/loader";

export interface SpinnerProps {
    namespace?: string;
}

const Spinner: React.FC<SpinnerProps> = (props): React.ReactElement => {
    return (
        <div className={classNames('spinner-wrapper', props.namespace)}>
            <Loader />
        </div>
    );
};

export default Spinner;
